import React, { VFC, useState } from 'react';
import { Row, Col, Container } from 'react-grid-system';
import styled from 'styled-components';
import Typography from '../atoms/Typography';
import IconButton from '../molecules/IconButton';
import StatusBox from '../molecules/StatusBox';
import TableItem from '../molecules/TableItem';
import { theme } from '../../utils/theme';
import Spacing from '../atoms/Spacing';
import ReturnForm from './form/ReturnForm';

import { useSettings } from '../../contexts/settingsContext';
import SvgIcon from '../atoms/SvgIcon';
import useStatusMessage from '../../hooks/useStatusMessage';
import Divider from '../atoms/Divider';
import { tOrderLine } from '../../contexts/zod';

interface Props {
  radius: string;
  added: boolean;
}

const Border = styled(Container)<Props>`
  background-color: white;
  border-radius: ${({ radius }) => `${radius}`};
  border: ${({ added }) => (added ? '2px solid #4CAF50' : '1px solid #e0e0e0')};
  padding-top: 32px;
  padding-bottom: 32px;
  margin-bottom: 32px;
`;

const ProductOrderListItem: VFC<tOrderLine> = (props) => {
  const [open, setOpen] = useState(false);
  const { cornerRadius } = useSettings();

  const {
    orderNumber,
    orderDate,
    quantity,
    shippedQuantity,
    labelTranslationKey,
    mayBeReturned,
  } = props;

  console.log({ props });
  const { exists, numberOfItems } = useStatusMessage(props);

  const table = [
    {
      key: 'order_no',
      title: <Typography translateKey="order_no" variant="body1-semi-bold" />,
      value: orderNumber,
    },
    {
      key: 'order_date',
      title: <Typography translateKey="order_date" variant="body1-semi-bold" />,
      value: orderDate,
    },
    {
      key: 'quantity',
      title: <Typography translateKey="quantity" variant="body1-semi-bold" />,
      value: `${quantity}/${shippedQuantity}`,
    },
  ];

  return (
    <Border radius={cornerRadius} added={exists}>
      <Row>
        <Col md={12} lg={12} xxl={12}>
          <Row justify="between">
            <Col>
              <Row nogutter>
                <Col sm="content">
                  <StatusBox title={labelTranslationKey} />
                  <Spacing spacing={2} />
                </Col>
                <Spacing horizontal spacing={3} />
                {exists && (
                  <Col>
                    <Row nogutter align="center">
                      <Col sm="content">
                        <SvgIcon
                          icon="package"
                          iconSize="large"
                          color="black"
                        />
                      </Col>
                      <Spacing horizontal />
                      <Col sm="content">
                        <Typography
                          translateKey="products_in_return_basket"
                          translateParams={{ added: numberOfItems, quantity }}
                          variant="h5"
                        />
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>
            </Col>
            <Col>
              {mayBeReturned &&
                labelTranslationKey === 'label_returnable' &&
                quantity !== numberOfItems && (
                  <Row justify="end">
                    <IconButton
                      icon={open ? 'minus' : 'plus'}
                      iconColor={theme.colors.grey[100]}
                      backgroundColor={theme.colors.grey[40]}
                      onClick={() => setOpen(!open)}
                    />
                  </Row>
                )}
            </Col>
            <Spacing horizontal spacing={4} />
          </Row>

          <Row>
            <Spacing horizontal spacing={4} />
            {table.map(({ title, value, key }) => (
              <TableItem key={key} title={title} value={value} />
            ))}
          </Row>
        </Col>
      </Row>
      {open && (
        <>
          <Spacing spacing={4} />
          <Row align="center" nogutter>
            <Col sm="content">
              <Typography translateKey="fill_in_form" variant="h3" />
            </Col>
            <Spacing horizontal spacing={2} />
            <Col>
              <Divider />
            </Col>
          </Row>
          <Spacing spacing={3} />
          <ReturnForm {...props} layout="orderLine" setOpen={setOpen} />
        </>
      )}
    </Border>
  );
};

export default ProductOrderListItem;
